/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import AqaReader from './AqaReader';
import AqaWriter from './AqaWriter';
import Store from './Store';

/**
 * The AqaVectorColours model module.
 * @module model/AqaVectorColours
 * @version v0
 */
export default class AqaVectorColours {
  /**
   * Constructs a new <code>AqaVectorColours</code>.
   * @alias module:model/AqaVectorColours
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaVectorColours</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaVectorColours} obj Optional instance to populate.
   * @return {module:model/AqaVectorColours} The populated <code>AqaVectorColours</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaVectorColours();
      if (data.hasOwnProperty('filename'))
        obj.filename = ApiClient.convertToType(data['filename'], 'String');
      if (data.hasOwnProperty('fileSize'))
        obj.fileSize = ApiClient.convertToType(data['fileSize'], 'Number');
      if (data.hasOwnProperty('store'))
        obj.store = Store.constructFromObject(data['store']);
      if (data.hasOwnProperty('file'))
        obj.file = ApiClient.convertToType(data['file'], 'Blob');
      if (data.hasOwnProperty('cellRags'))
        obj.cellRags = ApiClient.convertToType(data['cellRags'], ['Number']);
      if (data.hasOwnProperty('populationRag'))
        obj.populationRag = ApiClient.convertToType(data['populationRag'], 'String');
      if (data.hasOwnProperty('uniquenessRag'))
        obj.uniquenessRag = ApiClient.convertToType(data['uniquenessRag'], 'String');
      if (data.hasOwnProperty('numberRag'))
        obj.numberRag = ApiClient.convertToType(data['numberRag'], 'String');
      if (data.hasOwnProperty('dateRag'))
        obj.dateRag = ApiClient.convertToType(data['dateRag'], 'String');
      if (data.hasOwnProperty('stringRag'))
        obj.stringRag = ApiClient.convertToType(data['stringRag'], 'String');
      if (data.hasOwnProperty('typeRag'))
        obj.typeRag = ApiClient.convertToType(data['typeRag'], 'String');
      if (data.hasOwnProperty('nativeErrorRag'))
        obj.nativeErrorRag = ApiClient.convertToType(data['nativeErrorRag'], 'String');
      if (data.hasOwnProperty('numberOfPopulationQualityDefinitions'))
        obj.numberOfPopulationQualityDefinitions = ApiClient.convertToType(data['numberOfPopulationQualityDefinitions'], 'Number');
      if (data.hasOwnProperty('numberOfUniquenessQualityDefinitions'))
        obj.numberOfUniquenessQualityDefinitions = ApiClient.convertToType(data['numberOfUniquenessQualityDefinitions'], 'Number');
      if (data.hasOwnProperty('numberOfNumberQualityDefinitions'))
        obj.numberOfNumberQualityDefinitions = ApiClient.convertToType(data['numberOfNumberQualityDefinitions'], 'Number');
      if (data.hasOwnProperty('numberOfDateQualityDefinitions'))
        obj.numberOfDateQualityDefinitions = ApiClient.convertToType(data['numberOfDateQualityDefinitions'], 'Number');
      if (data.hasOwnProperty('numberOfStringQualityDefinitions'))
        obj.numberOfStringQualityDefinitions = ApiClient.convertToType(data['numberOfStringQualityDefinitions'], 'Number');
      if (data.hasOwnProperty('numberOfTypeQualityDefinitions'))
        obj.numberOfTypeQualityDefinitions = ApiClient.convertToType(data['numberOfTypeQualityDefinitions'], 'Number');
      if (data.hasOwnProperty('numberOfNativeErrorQualityDefinitions'))
        obj.numberOfNativeErrorQualityDefinitions = ApiClient.convertToType(data['numberOfNativeErrorQualityDefinitions'], 'Number');
      if (data.hasOwnProperty('numberOfPopulationReds'))
        obj.numberOfPopulationReds = ApiClient.convertToType(data['numberOfPopulationReds'], 'Number');
      if (data.hasOwnProperty('numberOfPopulationAmbers'))
        obj.numberOfPopulationAmbers = ApiClient.convertToType(data['numberOfPopulationAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfUniquenessReds'))
        obj.numberOfUniquenessReds = ApiClient.convertToType(data['numberOfUniquenessReds'], 'Number');
      if (data.hasOwnProperty('numberOfUniquenessAmbers'))
        obj.numberOfUniquenessAmbers = ApiClient.convertToType(data['numberOfUniquenessAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfNumberReds'))
        obj.numberOfNumberReds = ApiClient.convertToType(data['numberOfNumberReds'], 'Number');
      if (data.hasOwnProperty('numberOfNumberAmbers'))
        obj.numberOfNumberAmbers = ApiClient.convertToType(data['numberOfNumberAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDateReds'))
        obj.numberOfDateReds = ApiClient.convertToType(data['numberOfDateReds'], 'Number');
      if (data.hasOwnProperty('numberOfDateAmbers'))
        obj.numberOfDateAmbers = ApiClient.convertToType(data['numberOfDateAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfStringReds'))
        obj.numberOfStringReds = ApiClient.convertToType(data['numberOfStringReds'], 'Number');
      if (data.hasOwnProperty('numberOfStringAmbers'))
        obj.numberOfStringAmbers = ApiClient.convertToType(data['numberOfStringAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfTypeReds'))
        obj.numberOfTypeReds = ApiClient.convertToType(data['numberOfTypeReds'], 'Number');
      if (data.hasOwnProperty('numberOfTypeAmbers'))
        obj.numberOfTypeAmbers = ApiClient.convertToType(data['numberOfTypeAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfNativeErrorReds'))
        obj.numberOfNativeErrorReds = ApiClient.convertToType(data['numberOfNativeErrorReds'], 'Number');
      if (data.hasOwnProperty('numberOfNativeErrorAmbers'))
        obj.numberOfNativeErrorAmbers = ApiClient.convertToType(data['numberOfNativeErrorAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscretePopulationReds'))
        obj.numberOfDiscretePopulationReds = ApiClient.convertToType(data['numberOfDiscretePopulationReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscretePopulationAmbers'))
        obj.numberOfDiscretePopulationAmbers = ApiClient.convertToType(data['numberOfDiscretePopulationAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteUniquenessReds'))
        obj.numberOfDiscreteUniquenessReds = ApiClient.convertToType(data['numberOfDiscreteUniquenessReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteUniquenessAmbers'))
        obj.numberOfDiscreteUniquenessAmbers = ApiClient.convertToType(data['numberOfDiscreteUniquenessAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteNumberReds'))
        obj.numberOfDiscreteNumberReds = ApiClient.convertToType(data['numberOfDiscreteNumberReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteNumberAmbers'))
        obj.numberOfDiscreteNumberAmbers = ApiClient.convertToType(data['numberOfDiscreteNumberAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteNumberFormatAmbers'))
        obj.numberOfDiscreteNumberFormatAmbers = ApiClient.convertToType(data['numberOfDiscreteNumberFormatAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteNumberFormatReds'))
        obj.numberOfDiscreteNumberFormatReds = ApiClient.convertToType(data['numberOfDiscreteNumberFormatReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteNumberBoundaryAmbers'))
        obj.numberOfDiscreteNumberBoundaryAmbers = ApiClient.convertToType(data['numberOfDiscreteNumberBoundaryAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteNumberBoundaryReds'))
        obj.numberOfDiscreteNumberBoundaryReds = ApiClient.convertToType(data['numberOfDiscreteNumberBoundaryReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteDateReds'))
        obj.numberOfDiscreteDateReds = ApiClient.convertToType(data['numberOfDiscreteDateReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteDateAmbers'))
        obj.numberOfDiscreteDateAmbers = ApiClient.convertToType(data['numberOfDiscreteDateAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteDateFormatAmbers'))
        obj.numberOfDiscreteDateFormatAmbers = ApiClient.convertToType(data['numberOfDiscreteDateFormatAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteDateFormatReds'))
        obj.numberOfDiscreteDateFormatReds = ApiClient.convertToType(data['numberOfDiscreteDateFormatReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteDateBoundaryAmbers'))
        obj.numberOfDiscreteDateBoundaryAmbers = ApiClient.convertToType(data['numberOfDiscreteDateBoundaryAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteDateBoundaryReds'))
        obj.numberOfDiscreteDateBoundaryReds = ApiClient.convertToType(data['numberOfDiscreteDateBoundaryReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteStringReds'))
        obj.numberOfDiscreteStringReds = ApiClient.convertToType(data['numberOfDiscreteStringReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteStringAmbers'))
        obj.numberOfDiscreteStringAmbers = ApiClient.convertToType(data['numberOfDiscreteStringAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteStringAllowedAmbers'))
        obj.numberOfDiscreteStringAllowedAmbers = ApiClient.convertToType(data['numberOfDiscreteStringAllowedAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteStringAllowedReds'))
        obj.numberOfDiscreteStringAllowedReds = ApiClient.convertToType(data['numberOfDiscreteStringAllowedReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteStringBoundaryAmbers'))
        obj.numberOfDiscreteStringBoundaryAmbers = ApiClient.convertToType(data['numberOfDiscreteStringBoundaryAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteStringBoundaryReds'))
        obj.numberOfDiscreteStringBoundaryReds = ApiClient.convertToType(data['numberOfDiscreteStringBoundaryReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteStringFormatAmbers'))
        obj.numberOfDiscreteStringFormatAmbers = ApiClient.convertToType(data['numberOfDiscreteStringFormatAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteStringFormatReds'))
        obj.numberOfDiscreteStringFormatReds = ApiClient.convertToType(data['numberOfDiscreteStringFormatReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteTypeReds'))
        obj.numberOfDiscreteTypeReds = ApiClient.convertToType(data['numberOfDiscreteTypeReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteTypeAmbers'))
        obj.numberOfDiscreteTypeAmbers = ApiClient.convertToType(data['numberOfDiscreteTypeAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteNativeErrorReds'))
        obj.numberOfDiscreteNativeErrorReds = ApiClient.convertToType(data['numberOfDiscreteNativeErrorReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteNativeErrorAmbers'))
        obj.numberOfDiscreteNativeErrorAmbers = ApiClient.convertToType(data['numberOfDiscreteNativeErrorAmbers'], 'Number');
      if (data.hasOwnProperty('timestamp'))
        obj.timestamp = ApiClient.convertToType(data['timestamp'], 'Number');
      if (data.hasOwnProperty('vectorId'))
        obj.vectorId = ApiClient.convertToType(data['vectorId'], 'Number');
      if (data.hasOwnProperty('set'))
        obj.set = ApiClient.convertToType(data['set'], 'Boolean');
      if (data.hasOwnProperty('rag'))
        obj.rag = ApiClient.convertToType(data['rag'], 'String');
      if (data.hasOwnProperty('populationAndUniquenessRags'))
        obj.populationAndUniquenessRags = ApiClient.convertToType(data['populationAndUniquenessRags'], 'Blob');
      if (data.hasOwnProperty('numberFormatAndBoundaryRags'))
        obj.numberFormatAndBoundaryRags = ApiClient.convertToType(data['numberFormatAndBoundaryRags'], 'Blob');
      if (data.hasOwnProperty('dateFormatAndBoundaryRags'))
        obj.dateFormatAndBoundaryRags = ApiClient.convertToType(data['dateFormatAndBoundaryRags'], 'Blob');
      if (data.hasOwnProperty('stringLengthsAndValueRags'))
        obj.stringLengthsAndValueRags = ApiClient.convertToType(data['stringLengthsAndValueRags'], 'Blob');
      if (data.hasOwnProperty('typeAndNativeErrorRags'))
        obj.typeAndNativeErrorRags = ApiClient.convertToType(data['typeAndNativeErrorRags'], 'Blob');
      if (data.hasOwnProperty('writer'))
        obj.writer = AqaWriter.constructFromObject(data['writer']);
      if (data.hasOwnProperty('reader'))
        obj.reader = AqaReader.constructFromObject(data['reader']);
    }
    return obj;
  }
}

/**
 * @member {String} filename
 */
AqaVectorColours.prototype.filename = undefined;

/**
 * @member {Number} fileSize
 */
AqaVectorColours.prototype.fileSize = undefined;

/**
 * @member {module:model/Store} store
 */
AqaVectorColours.prototype.store = undefined;

/**
 * @member {Blob} file
 */
AqaVectorColours.prototype.file = undefined;

/**
 * @member {Array.<Number>} cellRags
 */
AqaVectorColours.prototype.cellRags = undefined;

/**
 * Allowed values for the <code>populationRag</code> property.
 * @enum {String}
 * @readonly
 */
AqaVectorColours.PopulationRagEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaVectorColours.PopulationRagEnum} populationRag
 */
AqaVectorColours.prototype.populationRag = undefined;

/**
 * Allowed values for the <code>uniquenessRag</code> property.
 * @enum {String}
 * @readonly
 */
AqaVectorColours.UniquenessRagEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaVectorColours.UniquenessRagEnum} uniquenessRag
 */
AqaVectorColours.prototype.uniquenessRag = undefined;

/**
 * Allowed values for the <code>numberRag</code> property.
 * @enum {String}
 * @readonly
 */
AqaVectorColours.NumberRagEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaVectorColours.NumberRagEnum} numberRag
 */
AqaVectorColours.prototype.numberRag = undefined;

/**
 * Allowed values for the <code>dateRag</code> property.
 * @enum {String}
 * @readonly
 */
AqaVectorColours.DateRagEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaVectorColours.DateRagEnum} dateRag
 */
AqaVectorColours.prototype.dateRag = undefined;

/**
 * Allowed values for the <code>stringRag</code> property.
 * @enum {String}
 * @readonly
 */
AqaVectorColours.StringRagEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaVectorColours.StringRagEnum} stringRag
 */
AqaVectorColours.prototype.stringRag = undefined;

/**
 * Allowed values for the <code>typeRag</code> property.
 * @enum {String}
 * @readonly
 */
AqaVectorColours.TypeRagEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaVectorColours.TypeRagEnum} typeRag
 */
AqaVectorColours.prototype.typeRag = undefined;

/**
 * Allowed values for the <code>nativeErrorRag</code> property.
 * @enum {String}
 * @readonly
 */
AqaVectorColours.NativeErrorRagEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaVectorColours.NativeErrorRagEnum} nativeErrorRag
 */
AqaVectorColours.prototype.nativeErrorRag = undefined;

/**
 * @member {Number} numberOfPopulationQualityDefinitions
 */
AqaVectorColours.prototype.numberOfPopulationQualityDefinitions = undefined;

/**
 * @member {Number} numberOfUniquenessQualityDefinitions
 */
AqaVectorColours.prototype.numberOfUniquenessQualityDefinitions = undefined;

/**
 * @member {Number} numberOfNumberQualityDefinitions
 */
AqaVectorColours.prototype.numberOfNumberQualityDefinitions = undefined;

/**
 * @member {Number} numberOfDateQualityDefinitions
 */
AqaVectorColours.prototype.numberOfDateQualityDefinitions = undefined;

/**
 * @member {Number} numberOfStringQualityDefinitions
 */
AqaVectorColours.prototype.numberOfStringQualityDefinitions = undefined;

/**
 * @member {Number} numberOfTypeQualityDefinitions
 */
AqaVectorColours.prototype.numberOfTypeQualityDefinitions = undefined;

/**
 * @member {Number} numberOfNativeErrorQualityDefinitions
 */
AqaVectorColours.prototype.numberOfNativeErrorQualityDefinitions = undefined;

/**
 * @member {Number} numberOfPopulationReds
 */
AqaVectorColours.prototype.numberOfPopulationReds = undefined;

/**
 * @member {Number} numberOfPopulationAmbers
 */
AqaVectorColours.prototype.numberOfPopulationAmbers = undefined;

/**
 * @member {Number} numberOfUniquenessReds
 */
AqaVectorColours.prototype.numberOfUniquenessReds = undefined;

/**
 * @member {Number} numberOfUniquenessAmbers
 */
AqaVectorColours.prototype.numberOfUniquenessAmbers = undefined;

/**
 * @member {Number} numberOfNumberReds
 */
AqaVectorColours.prototype.numberOfNumberReds = undefined;

/**
 * @member {Number} numberOfNumberAmbers
 */
AqaVectorColours.prototype.numberOfNumberAmbers = undefined;

/**
 * @member {Number} numberOfDateReds
 */
AqaVectorColours.prototype.numberOfDateReds = undefined;

/**
 * @member {Number} numberOfDateAmbers
 */
AqaVectorColours.prototype.numberOfDateAmbers = undefined;

/**
 * @member {Number} numberOfStringReds
 */
AqaVectorColours.prototype.numberOfStringReds = undefined;

/**
 * @member {Number} numberOfStringAmbers
 */
AqaVectorColours.prototype.numberOfStringAmbers = undefined;

/**
 * @member {Number} numberOfTypeReds
 */
AqaVectorColours.prototype.numberOfTypeReds = undefined;

/**
 * @member {Number} numberOfTypeAmbers
 */
AqaVectorColours.prototype.numberOfTypeAmbers = undefined;

/**
 * @member {Number} numberOfNativeErrorReds
 */
AqaVectorColours.prototype.numberOfNativeErrorReds = undefined;

/**
 * @member {Number} numberOfNativeErrorAmbers
 */
AqaVectorColours.prototype.numberOfNativeErrorAmbers = undefined;

/**
 * @member {Number} numberOfDiscretePopulationReds
 */
AqaVectorColours.prototype.numberOfDiscretePopulationReds = undefined;

/**
 * @member {Number} numberOfDiscretePopulationAmbers
 */
AqaVectorColours.prototype.numberOfDiscretePopulationAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteUniquenessReds
 */
AqaVectorColours.prototype.numberOfDiscreteUniquenessReds = undefined;

/**
 * @member {Number} numberOfDiscreteUniquenessAmbers
 */
AqaVectorColours.prototype.numberOfDiscreteUniquenessAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteNumberReds
 */
AqaVectorColours.prototype.numberOfDiscreteNumberReds = undefined;

/**
 * @member {Number} numberOfDiscreteNumberAmbers
 */
AqaVectorColours.prototype.numberOfDiscreteNumberAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteNumberFormatAmbers
 */
AqaVectorColours.prototype.numberOfDiscreteNumberFormatAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteNumberFormatReds
 */
AqaVectorColours.prototype.numberOfDiscreteNumberFormatReds = undefined;

/**
 * @member {Number} numberOfDiscreteNumberBoundaryAmbers
 */
AqaVectorColours.prototype.numberOfDiscreteNumberBoundaryAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteNumberBoundaryReds
 */
AqaVectorColours.prototype.numberOfDiscreteNumberBoundaryReds = undefined;

/**
 * @member {Number} numberOfDiscreteDateReds
 */
AqaVectorColours.prototype.numberOfDiscreteDateReds = undefined;

/**
 * @member {Number} numberOfDiscreteDateAmbers
 */
AqaVectorColours.prototype.numberOfDiscreteDateAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteDateFormatAmbers
 */
AqaVectorColours.prototype.numberOfDiscreteDateFormatAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteDateFormatReds
 */
AqaVectorColours.prototype.numberOfDiscreteDateFormatReds = undefined;

/**
 * @member {Number} numberOfDiscreteDateBoundaryAmbers
 */
AqaVectorColours.prototype.numberOfDiscreteDateBoundaryAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteDateBoundaryReds
 */
AqaVectorColours.prototype.numberOfDiscreteDateBoundaryReds = undefined;

/**
 * @member {Number} numberOfDiscreteStringReds
 */
AqaVectorColours.prototype.numberOfDiscreteStringReds = undefined;

/**
 * @member {Number} numberOfDiscreteStringAmbers
 */
AqaVectorColours.prototype.numberOfDiscreteStringAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteStringAllowedAmbers
 */
AqaVectorColours.prototype.numberOfDiscreteStringAllowedAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteStringAllowedReds
 */
AqaVectorColours.prototype.numberOfDiscreteStringAllowedReds = undefined;

/**
 * @member {Number} numberOfDiscreteStringBoundaryAmbers
 */
AqaVectorColours.prototype.numberOfDiscreteStringBoundaryAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteStringBoundaryReds
 */
AqaVectorColours.prototype.numberOfDiscreteStringBoundaryReds = undefined;

/**
 * @member {Number} numberOfDiscreteStringFormatAmbers
 */
AqaVectorColours.prototype.numberOfDiscreteStringFormatAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteStringFormatReds
 */
AqaVectorColours.prototype.numberOfDiscreteStringFormatReds = undefined;

/**
 * @member {Number} numberOfDiscreteTypeReds
 */
AqaVectorColours.prototype.numberOfDiscreteTypeReds = undefined;

/**
 * @member {Number} numberOfDiscreteTypeAmbers
 */
AqaVectorColours.prototype.numberOfDiscreteTypeAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteNativeErrorReds
 */
AqaVectorColours.prototype.numberOfDiscreteNativeErrorReds = undefined;

/**
 * @member {Number} numberOfDiscreteNativeErrorAmbers
 */
AqaVectorColours.prototype.numberOfDiscreteNativeErrorAmbers = undefined;

/**
 * @member {Number} timestamp
 */
AqaVectorColours.prototype.timestamp = undefined;

/**
 * @member {Number} vectorId
 */
AqaVectorColours.prototype.vectorId = undefined;

/**
 * @member {Boolean} set
 */
AqaVectorColours.prototype.set = undefined;

/**
 * Allowed values for the <code>rag</code> property.
 * @enum {String}
 * @readonly
 */
AqaVectorColours.RagEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaVectorColours.RagEnum} rag
 */
AqaVectorColours.prototype.rag = undefined;

/**
 * @member {Blob} populationAndUniquenessRags
 */
AqaVectorColours.prototype.populationAndUniquenessRags = undefined;

/**
 * @member {Blob} numberFormatAndBoundaryRags
 */
AqaVectorColours.prototype.numberFormatAndBoundaryRags = undefined;

/**
 * @member {Blob} dateFormatAndBoundaryRags
 */
AqaVectorColours.prototype.dateFormatAndBoundaryRags = undefined;

/**
 * @member {Blob} stringLengthsAndValueRags
 */
AqaVectorColours.prototype.stringLengthsAndValueRags = undefined;

/**
 * @member {Blob} typeAndNativeErrorRags
 */
AqaVectorColours.prototype.typeAndNativeErrorRags = undefined;

/**
 * @member {module:model/AqaWriter} writer
 */
AqaVectorColours.prototype.writer = undefined;

/**
 * @member {module:model/AqaReader} reader
 */
AqaVectorColours.prototype.reader = undefined;

